import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Tooltip, IconButton, Button } from '@material-ui/core'
import { COLORES } from '../../../config/colores'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../config/forms'
import CalendarioCargas from '../../Buque/containers/anunciosbuques/CalendarioCargas'
import EstimacionSemanalCereal from './EstimacionSemanalCereal'
import CloseIcon from '@material-ui/icons/Close'
import SimulacionProyeccion from './SimulacionProyeccion'
import {
  actualizarSimulacionActiva,
  updateIsSimulacion,
  updateFechaCalendario,
  resetShowDestalleCuposADescargar,
  actualizarExportadorProyeccion,
  obtenerEspacioDisponibleElevador,
  obtenerEspacioMaximoElevador,
  obtenerProyeccionExportador,
  obtenerCuposVigentes
} from '../actions/listados'
import { obtenerParametroCumplimiento, obtenerParametroCamion } from '../actions'
import DetalleCuposPorFecha from '../components/estimacionStock/DetalleCuposPorFecha'
import ProyeccionExportador from './ProyeccionExportador'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../config/settings'
import EspacioDisponible from '../components/estimacionStock/EspacioDisponible'
import DetalleFechaProyeccion from '../components/estimacionStock/DetalleFechaProyeccion'

function ProyeccionStock (props) {
  const {
    roles,
    actualizarSimulacionActiva,
    datosOk,
    obtenerParametroCumplimiento,
    obtenerParametroCamion,
    obtenerEspacioDisponibleElevador,
    obtenerEspacioMaximoElevador,
    obtenerProyeccionExportador,
    cuposProyectados,
    obtenerCuposVigentes
  } = props
  const [showSimulacion, setShowSimulacion] = useState(false)

  const rolAutorizado = roles.includes('SUPERVISOR') || roles.includes('DESARROLLADOR')

  useEffect(() => {
    obtenerParametroCamion()
    obtenerParametroCumplimiento()
    obtenerEspacioDisponibleElevador()
    obtenerEspacioMaximoElevador()
    obtenerProyeccionExportador()
    obtenerCuposVigentes()
  }, [
    obtenerParametroCamion,
    obtenerParametroCumplimiento,
    obtenerEspacioDisponibleElevador,
    obtenerEspacioMaximoElevador,
    obtenerProyeccionExportador,
    obtenerCuposVigentes
  ])

  const handleOpen = () => {
    const { change: formChange } = props
    setShowSimulacion(true)
    props.updateIsSimulacion(true)
    props.updateFechaCalendario(null)
    actualizarSimulacionActiva(true)
    formChange('exportadorProyeccion', '')
    props.actualizarExportadorProyeccion(null)
    props.resetShowDestalleCuposADescargar()
    obtenerProyeccionExportador()
  }

  const handleClose = () => {
    setShowSimulacion(false)
    props.updateIsSimulacion(false)
    props.obtenerProyeccionExportador()
    actualizarSimulacionActiva(false)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div style={{ marginTop: '-4%' }}>
        { rolAutorizado && !showSimulacion && datosOk &&
          <>
            <Button
              variant='contained'
              style={{ backgroundColor: COLORES.violet, color: 'white', fontWeight: 'bold' }}
              onClick={handleOpen}
            >
              Ir a simulación
            </Button>
          </>
        }

        {!showSimulacion
          ? <Row>
            <Col md={8}>
              <EstimacionSemanalCereal />
              <DetalleCuposPorFecha />
              <DetalleFechaProyeccion />
              { cuposProyectados && <ProyeccionExportador /> }
            </Col>
            <Col md={4} style={{ margin: '0 auto' }}>
              <div style={{ margin: '2% 1%' }}>
                <EspacioDisponible />
              </div>
              <CalendarioCargas />
            </Col>
          </Row>

          : <>
            <Tooltip title='Cerrar simulación' >
              <IconButton onClick={handleClose} style={{ position: 'fixed', top: '8%', right: 0 }} >
                <CloseIcon />
              </IconButton>
            </Tooltip>

            <SimulacionProyeccion />
            <Col md={9}>
              { cuposProyectados && <ProyeccionExportador /> }
            </Col>
          </>
        }
      </div>

    </>
  )
}

const mapStateToProps = (state) => ({
  roles: state.auth.roles,
  datosOk: state.stock.receiveEstimacionExportadores,
  cuposProyectados: state.stock.cuposProyectados
  // fechaProyeccion: state.stock.fechaProyeccion
})

const mapActionsToProps = {
  actualizarSimulacionActiva,
  actualizarExportadorProyeccion,
  obtenerParametroCumplimiento,
  obtenerParametroCamion,
  updateIsSimulacion,
  updateFechaCalendario,
  resetShowDestalleCuposADescargar,
  obtenerEspacioDisponibleElevador,
  obtenerEspacioMaximoElevador,
  obtenerProyeccionExportador,
  obtenerCuposVigentes
}

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(ProyeccionStock))
